import { createReducer, createAction } from '@reduxjs/toolkit';
import { backendCall, createApiCall } from '@reducers/utils';
import type { AppDispatch } from '@store/types';
import type { MachineOperationState, MachineItem, ScheduledOperationsResponse, SearchMachinesResponse } from './types';

// Re-export types for consumers
export type { MachineOperationState, MachineItem, SearchMachinesResponse, ScheduledOperationsResponse } from './types';

// === Initial State ===

const initState: MachineOperationState = {
  machines: [],
  loaded: false,
  data: {},
  pageNumber: 1,
  pageSize: 20,
};

// === Actions ===

export const set = createAction<Record<string, unknown>>('machineOperation/set');
export const setMachines = createAction<MachineItem[]>('machineOperation/setMachines');
export const updatePage = createAction<number | undefined>('machineOperation/updatePage');
export const close = createAction('machineOperation/close');
export const clear = createAction('clear');

// === Thunks ===

export const getData = (machineId: number) => async (dispatch: AppDispatch) => {
  dispatch(close());
  await dispatch(
    backendCall(
      createApiCall((api) => api.machineOperation.get, {
        params: { id: machineId },
        onSuccess: (data: ScheduledOperationsResponse) => {
          dispatch(set(data as Record<string, unknown>));
        },
        onError: (error) => {
          console.log(error, 'error');
        },
      })
    )
  );
};

export const searchMachines = () => async (dispatch: AppDispatch) => {
  dispatch(updatePage(1));
  await dispatch(
    backendCall(
      createApiCall((api) => api.machineOperation.searchMachines, {
        params: {
          filters: {},
          includeInOutput: [
            'IncludeMachineConnection',
            'IncludeMachineStatus',
            'IncludePartDetails',
            'IncludeProductionOrderDetails',
            //'IncludeOperationDetails',
            "IncludeExtendedData"
          ],
        },
        onSuccess: (r: SearchMachinesResponse, { paginationString }) => {
          if (paginationString) {
            const pagination = JSON.parse(paginationString);
          }

          dispatch(setMachines(r.machines || []));
        },
        onError: (error) => {
          console.log(error, 'error');
          dispatch(setMachines([]));
        },
      })
    )
  );
};

// === Reducer ===

export default createReducer<MachineOperationState>(initState, (builder) => {
  builder
    .addCase(set, (state, action) => ({
      ...state,
      loaded: true,
      data: action.payload,
    }))
    .addCase(clear, () => {
      return initState;
    })
    .addCase(close, () => {
      return initState;
    })
    .addCase(updatePage, (state, action) => ({
      ...state,
      pageNumber: action.payload ? action.payload : state.pageNumber + 1,
    }))
    .addCase(setMachines, (state, action) => ({
      ...state,
      machines: action.payload,
      loaded: true,
    }));
});
